import { useEffect, useState } from 'react';

import appManager from 'AppManager';
import { PlayoutsResponse } from '@24i/st-api-connector';

export const usePlayouts = (platform: string): [string | null, PlayoutsResponse | undefined] => {
    const {
        backstageConnector: { vod }
    } = appManager.getApi();

    const [myPlatformSubscription, setMyPlatformSubscription] = useState<
        PlayoutsResponse | undefined
    >(undefined);
    const [myRenawalDate, setMyRenawalDate] = useState<string | null>(null);

    useEffect(() => {
        const getSubscriptionInfo = async () => {
            try {
                const myPlayouts = await vod.getPlayouts(platform);
                setMyPlatformSubscription(myPlayouts);
                setMyRenawalDate(myPlayouts.renewalDate);
            } catch (error) {
                console.log(error);
            }
        };
        getSubscriptionInfo();
    }, [platform, vod]);
    return [myRenawalDate, myPlatformSubscription] as [
        typeof myRenawalDate,
        typeof myPlatformSubscription
    ];
};

export default usePlayouts;
